import { CartContextProvider } from "context/CartContext";
import React from "react";
import ReactDOM from "react-dom";
import "../src/pages/OrderStatusInfo.css";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";

ReactDOM.render(
  <CartContextProvider>
    <App />
  </CartContextProvider>,
  document.getElementById("root")
);
